import type {
	Components,
} from '@mui/material'

export const materialUISVGIconTheme: {
	components: Components
} = {
	components: {
		MuiSvgIcon: {
			defaultProps: {
				component: 'span',
				color:     'on-surface',
			},
			styleOverrides: {
				root: {
					transition: 'color 0.2s ease 0s',
				},
			},
			variants: [

				/* colors */
				{
					props: {
						color: 'on-surface',
					},
					style: {
						color: 'var(--on-surface-color)',
					},
				},
				{
					props: {
						color: 'primary',
					},
					style: {
						color: 'var(--primary-color)',
					},
				},
				{
					props: {
						color: 'on-primary',
					},
					style: {
						color: 'var(--on-primary-color)',
					},
				},
				{
					props: {
						color: 'secondary',
					},
					style: {
						color: 'var(--secondary-color)',
					},
				},
				{
					props: {
						color: 'on-secondary',
					},
					style: {
						color: 'var(--on-secondary-color)',
					},
				},
				{
					props: {
						color: 'on-accent',
					},
					style: {
						color: 'var(--on-accent-color)',
					},
				},
				{
					props: {
						color: 'gray-100',
					},
					style: {
						color: 'var(--gray-color-100)',
					},
				},
				{
					props: {
						color: 'gray-200',
					},
					style: {
						color: 'var(--gray-color-200)',
					},
				},
				{
					props: {
						color: 'gray-300',
					},
					style: {
						color: 'var(--gray-color-300)',
					},
				},
				{
					props: {
						color: 'gray-400',
					},
					style: {
						color: 'var(--gray-color-400)',
					},
				},
				{
					props: {
						color: 'gray-500',
					},
					style: {
						color: 'var(--gray-color-500)',
					},
				},
				{
					props: {
						color: 'gray-600',
					},
					style: {
						color: 'var(--gray-color-600)',
					},
				},
				{
					props: {
						color: 'gray-700',
					},
					style: {
						color: 'var(--gray-color-700)',
					},
				},
				{
					props: {
						color: 'gray-800',
					},
					style: {
						color: 'var(--gray-color-800)',
					},
				},
				{
					props: {
						color: 'gray-900',
					},
					style: {
						color: 'var(--gray-color-900)',
					},
				},
			],
		},
	},
}
